import React from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';
import CooldownBanner from './CooldownBanner';
import AboutTradition from './AboutTradition';
import MuhurtaQualityBadge from '../shared/MuhurtaQualityBadge';

const Container = styled.section`
  max-width: 720px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: ${p => p.theme.breakpoints.tablet}px) {
    max-width: 100%;
  }
`;

const Hero = styled.div`
  margin-top: ${p => p.theme.spacing[4]}px;
  margin-bottom: ${p => p.theme.spacing[5]}px;
`;

const Motif = styled.div`
  font-size: 48px;
  margin-bottom: ${p => p.theme.spacing[2]}px;
  line-height: 1;
`;

const TitleTa = styled.h1`
  font-family: 'Noto Sans Tamil', 'Playfair Display', Georgia, serif;
  font-size: 28px;
  color: #8B4513;
  margin: 0 0 ${p => p.theme.spacing[1]}px;
`;

const TitleEn = styled.h2`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 18px;
  color: ${p => p.theme.colors.text.secondary};
  font-weight: 400;
  margin: 0;
`;

const Invitation = styled.p`
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 1.6;
  color: ${p => p.theme.colors.text.primary};
  margin: ${p => p.theme.spacing[4]}px 0;
`;

const Instructions = styled.ol`
  text-align: left;
  max-width: 480px;
  margin: 0 auto ${p => p.theme.spacing[5]}px;
  font-size: 14px;
  color: ${p => p.theme.colors.text.secondary};
  line-height: 1.8;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
`;

const BadgeWrap = styled.div`
  margin: 0 auto ${p => p.theme.spacing[4]}px;
  display: flex;
  justify-content: center;
`;

const BeginButton = styled.button`
  padding: 14px 48px;
  font-size: 18px;
  font-weight: 600;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  background: linear-gradient(135deg, #DAA520, #B8860B);
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  min-height: 44px;
  transition: opacity 0.3s ease, transform 0.2s ease;
  &:hover:not(:disabled) { transform: translateY(-2px); }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;

const LandingView = ({ onBegin, onViewLastReading, cooldown, lang }) => {
  const t = useLocale(lang, 'ramaShalaka');
  const showCooldownBanner = cooldown.active && cooldown.lastReadingCellIndex !== null;

  return (
    <Container>
      <Hero>
        <Motif aria-hidden="true">🏹</Motif>
        <TitleTa>{t.titleTa || 'ஸ்ரீ ராம சலாக பிரஶ்னாவலி'}</TitleTa>
        <TitleEn>{t.titleEn || 'Sri Rama Shalaka Prashnavali'}</TitleEn>
      </Hero>

      <Invitation>
        {t.invitation || "Hold a question in your heart and seek Sri Rama's blessing"}
      </Invitation>

      <Instructions>
        <li>{t.instruction1 || 'Close your eyes and focus on your question'}</li>
        <li>{t.instruction2 || 'When ready, tap anywhere on the grid'}</li>
        <li>{t.instruction3 || "The letters will reveal Sri Rama's guidance"}</li>
      </Instructions>

      <BadgeWrap>
        <MuhurtaQualityBadge lang={lang} />
      </BadgeWrap>

      <BeginButton onClick={onBegin} disabled={cooldown.active}>
        {t.beginButton || 'Begin'}
      </BeginButton>

      {showCooldownBanner && (
        <CooldownBanner
          msRemaining={cooldown.msRemaining}
          onViewLastReading={onViewLastReading}
          hasLastReading={cooldown.lastReadingCellIndex !== null}
          lang={lang}
        />
      )}

      <AboutTradition lang={lang} />
    </Container>
  );
};

export default LandingView;
